import React from 'react';
import { bool } from 'prop-types';
import { Box } from '@chakra-ui/react';

import ImgWaveV4 from './assets/wave-v4.svg';
import ImgWaveV4Primary from './assets/wave-v4-primary.svg';

function Wave({ isPrimary, ...rest }) {
  return (
    <Box
      bgImage={isPrimary ? ImgWaveV4Primary : ImgWaveV4}
      minHeight="40px"
      width="100%"
      {...rest}
    />
  );
}

Wave.propTypes = {
  isPrimary: bool,
};

Wave.defaultProps = {
  isPrimary: false,
};

export default React.memo(Wave);
